module.exports = __webpack_public_path__ + "static/media/takenProd.36868434.svg";